
import { Card, CardContent } from "@/components/ui/card";

const FAQSection = () => {
  return (
    <section className="py-16 bg-white/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-teedee-blue mb-4">Frequently Asked Questions</h2>
          <p className="text-xl text-gray-600">
            Quick answers to common questions about Bobo & Teedee®
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <Card className="bg-white/60 shadow-lg border-2 border-teedee-blue/20">
            <CardContent className="p-6">
              <h3 className="text-lg font-bold text-teedee-blue mb-3">When are new episodes released?</h3>
              <p className="text-gray-600">We release new Bobo & Teedee® episodes every two weeks on our YouTube channel. Subscribe to never miss an adventure!</p>
            </CardContent>
          </Card>

          <Card className="bg-white/60 shadow-lg border-2 border-bobo-green/20">
            <CardContent className="p-6">
              <h3 className="text-lg font-bold text-bobo-green mb-3">Can I use activities in my classroom?</h3>
              <p className="text-gray-600">Absolutely! All our printable activities are free for educational use in classrooms, homeschool, and community programs.</p>
            </CardContent>
          </Card>

          <Card className="bg-white/60 shadow-lg border-2 border-brand-purple/20">
            <CardContent className="p-6">
              <h3 className="text-lg font-bold text-brand-purple mb-3">How can I partner with you?</h3>
              <p className="text-gray-600">We're always looking for partners who share our educational mission! Contact us through the form above to discuss opportunities.</p>
            </CardContent>
          </Card>

          <Card className="bg-white/60 shadow-lg border-2 border-golden-orange/20">
            <CardContent className="p-6">
              <h3 className="text-lg font-bold text-golden-orange mb-3">Is content appropriate for all ages?</h3>
              <p className="text-gray-600">Our content is designed for children ages 3-12, but families of all ages enjoy watching and learning together!</p>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
